// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homemobile_container_home__DGi7R {
    margin-top: 3%;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-content: flex-start;
  align-items: flex-start;
  align-self: center;
}

.homemobile_signup_block__cyzts{
 display: flex ;
 flex-direction: column;
 align-items: center;
 align-content: center;
 align-self: center;
}


.homemobile_logos__o3DfN {
  display: flex;
  flex: 1 1;
    align-content: flex-start;
  align-items: flex-start;
  align-self: center;
  vertical-align: bottom;

  width: 200px;
  height: 80px;
  margin-right: 15%; }

.homemobile_imageGroup_department_logos__AfYXP {
  display: flex;
  flex: 1 1;
  flex-direction: row;
  align-content: flex-start;
  align-items: flex-start;
  align-self: flex-start;

}


.homemobile_references_block__eMdAE {
  display: flex;
  flex: 1 1;
  flex-direction: row;
  align-content: center;
  align-items: center;
  align-self: flex-start;
  justify-content:space-evenly;
}


`, "",{"version":3,"sources":["webpack://./src/pages/Home/homemobile.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;EAChB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;CACC,cAAc;CACd,sBAAsB;CACtB,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;AACnB;;;AAGA;EACE,aAAa;EACb,SAAO;IACL,yBAAyB;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;;EAEtB,YAAY;EACZ,YAAY;EACZ,iBAAiB,EAAE;;AAErB;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;;AAExB;;;AAGA;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;AAC9B","sourcesContent":[".container_home {\r\n    margin-top: 3%;\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: center;\r\n}\r\n\r\n.signup_block{\r\n display: flex ;\r\n flex-direction: column;\r\n align-items: center;\r\n align-content: center;\r\n align-self: center;\r\n}\r\n\r\n\r\n.logos {\r\n  display: flex;\r\n  flex: 1;\r\n    align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: center;\r\n  vertical-align: bottom;\r\n\r\n  width: 200px;\r\n  height: 80px;\r\n  margin-right: 15%; }\r\n\r\n.imageGroup_department_logos {\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: row;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: flex-start;\r\n\r\n}\r\n\r\n\r\n.references_block {\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: row;\r\n  align-content: center;\r\n  align-items: center;\r\n  align-self: flex-start;\r\n  justify-content:space-evenly;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_home": `homemobile_container_home__DGi7R`,
	"signup_block": `homemobile_signup_block__cyzts`,
	"logos": `homemobile_logos__o3DfN`,
	"imageGroup_department_logos": `homemobile_imageGroup_department_logos__AfYXP`,
	"references_block": `homemobile_references_block__eMdAE`
};
export default ___CSS_LOADER_EXPORT___;
